import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <strong>Sampling of wetland plants</strong>
            </p>
            <p>
              Wetland plants were sampled from inlets and outlets of Jakkur
              Lake, Bengaluru on weekly basis by the quadrat (0.25 m<sup>2</sup>{" "}
              area). The plant samples were collected in triplicates. Collected
              macrophyte samples were washes, assigned labels and plant species
              were identified using standard morphological keys based on
              taxonomic literatures<sup>18</sup>.
            </p>
            <p>
              <strong>Remediation potential of wetland plants</strong>
            </p>
            <p>
              All the dried plant samples were powdered using mortar and pestle,
              sieved (1 mm) to get fine powders and labelled properly. The
              powdered plant sample (0.5 g) were acid digested<sup>19</sup> and
              analysed for six heavy metals viz., cadmium (Cd), chromium (Cr),
              copper (Cu), nickel (Ni), lead (Pb) and zinc (Zn) with reagent
              blanks and suitable standards using Flame Atomic Absorption
              Spectrophotometry (GBC Avanta version 1.31).&nbsp;&nbsp;
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
